import React from 'react';
import ToolLogo from './ToolLogo';

const StackGraphNode = ({ tool, nodeRef, dimmed, onPointerDown }) => (
  <div className="stack-graph-node" ref={nodeRef}>
    <div className={`stack-graph-node-inner${dimmed ? ' stack-graph-node--dimmed' : ''}`}>
      <div
        className="stack-graph-node-hit"
        aria-hidden="true"
        onPointerDown={onPointerDown}
      >
        <div className="tool-logo">
          <ToolLogo tool={tool} />
        </div>
      </div>
      <div className="stack-graph-tooltip">
        <h4>{tool.name}</h4>
        <p>{tool.description}</p>
      </div>
    </div>
  </div>
);

export default StackGraphNode;
